import auth from "@/services/CRMinitAuth"

const list = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/`, {
    params: query
  });
}

const listTask = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/task_list/`, {
    params: query
  });
}


const listReserve = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/top_cbr_reserve_queue/`, {
    params: query
  });
}

const listExchange = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/top_cbr_exchange_queue/`, {
    params: query
  });
}



const listWait = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/wait_list/`, {
    params: query
  });
}

const listReserveExchange = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/reserve_and_exchange_queue/`, {
    params: query
  });
}

const listReservedExchanged = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/reserved_and_exchanged/`, {
    params: query
  });
}

const listProcessed = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/processed/`, {
    params: query
  });
}

const listReservedAll = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/all_reserved/`, {
    params: query
  });
}

const listReservedAllWillCome = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/all_reserved_will_come/`, {
    params: query
  });
}

const listReservedAllWillNotCome = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/all_reserved_will_not_come/`, {
    params: query
  });
}

const listMijnCbrQueue = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/mijn_cbr_queue/`, {
    params: query
  });
}

const parseReservationNumber = (id) => {
  return auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/${id}/get_application_number/`)
}

const listTopCbrQueue = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/top_cbr_queue/`, {
    params: query
  });
}

const find = ID => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/${ID}/`);
}

const findSimilar = ID => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/${ID}/get_similar_candidates/`);
}

const findByNumber = number => {
  return auth.get(`${process.env.VUE_APP_CRM_API}candidates/get_by_number/`, {params: {
    number: number
  }});
}

const create = data => {
  return auth.post(`${process.env.VUE_APP_CRM_API}candidates/`, data);
}

const sendExchange = data => {
  return auth.post(`${process.env.VUE_APP_CRM_API}candidates_suggestions/add_suggested_exams/`, data);
}

const addRequests = data => {
  return auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/add_exam_requests/`, data);
}

const removeRequests = data => {
  return auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/delete_exam_requests/`, data);
}

const addCustomLog = (candidate_id, data) => {
  return auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/${candidate_id}/add_log/`, data);
}

const put = (ID, data) => {
  return auth.put(`${process.env.VUE_APP_CRM_API}candidates/${ID}/`, data);
}

const patch = (ID, data) => {
  return auth.patch(`${process.env.VUE_APP_CRM_API}candidates/${ID}/`, data);
}

const remove = ID => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/${ID}/archive/`)

const markAsProcessed = data => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/mark_as_processed/`, data)

const removeFromOnHold = data => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/remove_from_on_hold/`, data)

const getCandidateNumber = data => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/get_candidate_number/`, data)

const accept = data => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/accept/`, data)

const testAccept = data => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/test_acceptance/`, data)

const checkReservationQueueBulk = (data) => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/try_to_reserve/`, data)

const changeCourseBulk = (data) => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/change_course/`, data)

const setMijnExam = (ID, data) => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/${ID}/set_mijn_exam/`, data)

const removeMijnExam = ID =>
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/${ID}/delete_mijn_exam/`)

const assignLabels = data =>
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/bulk_assign_labels/`, data)

const unAssignLabels = data => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/bulk_delete_labels/`, data)

const sendEmail = (ID, data) => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/${ID}/send_email/`, data)

const sendEmailBulk = (data) => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/send_emails/`, data)

const bulkSuggestMIJN = data => {
  return auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/suggest_mijn_cbr_exam/`, data);
}

const removeFromAccept = data =>
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/un_accept/`, data)

const sync = data =>
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/topcbr_import/`, data)

const sendToLanding = ID =>
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/${ID}/send_to_landing/`)

const changeOnHold = data =>
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/change_on_hold/`, data)

const changeColor = (candidateIds, colorID) =>
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/change_color/`, { ids: candidateIds, color: colorID })

const courseConfigurationBulk = (data) => 
  auth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/change_course_configuration/`, data)
export default {
  sendToLanding,
  list,
  listTask,
  listWait,
  listReserveExchange,
  listReservedExchanged,
  listProcessed,
  listReservedAll,
  listMijnCbrQueue,
  listTopCbrQueue,
  find,
  findSimilar,
  findByNumber,
  put,
  bulkSuggestMIJN,
  patch,
  remove,
  markAsProcessed,
  removeFromOnHold,
  create,
  getCandidateNumber,
  accept,
  testAccept,
  checkReservationQueueBulk,
  sendExchange,
  changeCourseBulk,
  setMijnExam,
  removeMijnExam,
  assignLabels,
  unAssignLabels,
  sendEmail,
  sendEmailBulk,
  addRequests,
  removeRequests,
  removeFromAccept,
  sync,
  addCustomLog,
  changeOnHold,
  parseReservationNumber,
  listExchange,
  listReserve,
  changeColor,
  listReservedAllWillCome,
  listReservedAllWillNotCome,
  courseConfigurationBulk
}
